import React from 'react';
import { DatePicker } from 'antd';

const Wrapper = (Component) => (props) => (
  <div style={{ position: 'relative' }}>
    <Component {...props} getPopupContainer={(trigger) => trigger.parentNode} />
  </div>
);
const TDatePicker = Wrapper(DatePicker);

// @ts-ignore
TDatePicker.RangePicker = Wrapper(DatePicker.RangePicker);
// @ts-ignore
TDatePicker.MonthPicker = Wrapper(DatePicker.MonthPicker);

export default TDatePicker;
